import { ITruckData } from "./MainSection";

export const TruckMember = ({
  imgUri,
  social,
  name,
  tags,
  description,
}: ITruckData) => (
  <div
    className="col-lg-4 col-md-6 d-flex align-items-stretch"
    data-aos="fade-up"
    data-aos-delay="100"
  >
    <div className="chef-member">
      <div className="member-img">
        <img src={imgUri} className="img-fluid" alt="" />
        <div className="social">
          <a href={social.twitter}>
            <i className="bi bi-twitter"></i>
          </a>
          <a href={social.facebook}>
            <i className="bi bi-facebook"></i>
          </a>
          <a href={social.instagram}>
            <i className="bi bi-instagram"></i>
          </a>
          {/* <a href="https://#">
  <i className="bi bi-linkedin"></i>
</a> */}
        </div>
      </div>
      <div className="member-info">
        <h4>{name}</h4>
        {tags.map((tag) => (
          <span>{tag}</span>
        ))}
        <p>{description}</p>
      </div>
    </div>
  </div>
);
